import { SUBSCRIPTION_PLANS } from '~/constants'

export const getPromptDetais = plan => ([
  { icon: 'far fa-circle-dollar', text: `Earn ${plan === SUBSCRIPTION_PLANS.PRIME ? 1 : 0.5}% back on EVERY bill you pay!` },
  { icon: 'far fa-chart-line-up', text: 'Build your credit score FAST' },
  { icon: 'far fa-file-invoice-dollar', text: 'More compatible bills to link' }
])
